/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import React from 'react';
import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Atencion from '@panel/commons/assets/img/atencion.svg';
import Radio from '@panel/commons/lib/Input/InputRadio';
import { sendTrackingInfo } from '@panel/commons';
import Alert from '@panel/commons/lib/Alert/Alert';
import { ecommerceSites, addUrlParam } from '@panel/commons/helpers';
import { DesempenoSelectors, DesempenoOperations } from '../../ducks/desempeno';
import { filterCurrentPlan, getCredits } from '../../utils/helpers';
import { filterCredits } from '../../../../avisos/helpers/utils';

const UpgradePlanModal = ({
  onClose,
  publicationType,
  operationType,
  posting,
  device,
  isIntegrator,
  publisherId,
  postingId,
  publisherTypeId
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const ecommercePath = ecommerceSites(publisherTypeId, postingId);
  const { credits, publicationPlans } = useSelector(DesempenoSelectors.getDesempenoState);
  const { publishPosting, selectCredit } = DesempenoOperations;
  const isDevelopment = publicationType !== 'Clasificado';
  const postingPublicationPlanType = posting.publication_plan;
  const branchCredits = getCredits([postingId], publisherId, credits || []);
  const { isExclusiveZone, exclusiveZoneId } = posting;
  const arrayWithExclusiveZoneId = [];
  arrayWithExclusiveZoneId.push(exclusiveZoneId);

  let AvailableCredits = filterCredits(
    branchCredits.creditItems,
    isDevelopment,
    operationType,
    false,
    isExclusiveZone,
    arrayWithExclusiveZoneId,
    credits.exclusivePlans
  );

  const forbidenPlansForSaleFilter = () => {
    // se toman los planes de alquiler que no se pueden usar en venta
    const forbidenPlans = publicationPlans && publicationPlans['2'];
    // reviso si tiene operacion de venta en algun posting
    const isSaleOperation = operationType === 1;
    // filtro los planes prohibidos de los creditos disponibles
    if (isSaleOperation && forbidenPlans) {
      forbidenPlans.map(
        // eslint-disable-next-line array-callback-return
        plan => {
          if (plan) {
            AvailableCredits = AvailableCredits.filter(
              credit => plan.publication_plan_id !== credit.publicationPlanId.toString()
            );
          }
        }
      );
    }
  };

  forbidenPlansForSaleFilter();

  // Ahora se filtran los planes por peso:
  const filteredPlans = filterCurrentPlan(AvailableCredits, postingPublicationPlanType);
  const postingAndPublisherId = { [postingId]: publisherId };

  const publish = (postingToUpgrade, userCredits) => {
    onClose();
    const publishData = {
      postingIds: [postingId],
      postingAndPublisherId,
      publicationPlan: userCredits.reduce((selectedPlan, currentPlan) => {
        if (currentPlan.checked) selectedPlan = currentPlan.publicationPlanId;
        return selectedPlan;
      }, '')
    };
    dispatch(publishPosting(publishData));
  };

  const redirectToEcommerce = () => {
    window.location.href = `${window.location.origin}${addUrlParam(
      ecommercePath,
      isExclusiveZone ? 'ref=zonademand' : null
    )}`;
  };
  const noCredits = filteredPlans.length === 0;

  const getText = () => {
    if (noCredits) {
      if (isExclusiveZone) return t('panel.avisos.upgrade.plan.modal.no.credits.isExclusiveZone');
      return t('panel.avisos.upgrade.plan.modal.no.credits');
    }
    return isExclusiveZone
      ? t(`panel.avisos.publish.modal.text.isExclusiveZone`) + t('panel.avisos.upgrade.plan.modal.text')
      : t('panel.avisos.upgrade.plan.modal.text');
  };

  return (
    <Container device={device}>
      {filteredPlans.length === 0 && <Img src={Atencion} />}
      <Title data-panel='desempeno-upgradePlanModal-title'>
        {!noCredits ? t('panel.avisos.upgrade.plan.modal.title') : t('panel.avisos.upgradePlan.modal.title.no.credits')}
      </Title>
      <Text data-panel='desempeno-upgradePlanModal-text'>{getText()}</Text>
      {!noCredits && (
        <SubTitle data-panel='desempeno-upgradePlanModal-subTitle'>
          {t('panel.avisos.upgrade.plan.modal.other.plans')}
        </SubTitle>
      )}
      {filteredPlans.map(c => (
        <PlanContainer
          onClick={() => dispatch(selectCredit(c.publicationPlanId, publisherId))}
          key={`key-radio-planId-${c.publicationPlanId}`}
          disabled={false}
          device={device}
        >
          <label htmlFor={`radio-planId-${c.publicationPlanId}`}>
            <Radio
              name={`radio-planId-${c.publicationPlanId}`}
              checked={c.checked || false}
              onChange={e => {
                e.stopPropagation();
                dispatch(selectCredit(c.publicationPlanId, publisherId));
              }}
              marginRight='8'
              dataPanel={`desempeno-upgradePlanModal-radioButton-${c.publicationPlanId}`}
            />
            <span
              className={`upgradeModal-planName-${device}`}
              data-panel={`desempeno-upgradePlanModal-name-${c.publicationPlanId}`}
            >
              {c.name}
            </span>
          </label>
          <AvailableCreditsText data-panel={`desempeno-upgradePlanModal-availableCredits-${c.publicationPlanId}`}>
            {c.availableItems === 999999
              ? 'Ilimitado'
              : `${c.availableItems} ${t('panel.avisos.publish.modal.available')}`}
          </AvailableCreditsText>
        </PlanContainer>
      ))}
      {isIntegrator && <Alert message={t('panel.avisos.publish.modal.alert.integrador')} />}
      <ButtonContainer device={device}>
        {ecommercePath && (
          <Button
            onClick={() => {
              sendTrackingInfo('Panel', 'Mis avisos', 'Mejora tu plan-Comprar plan');
              redirectToEcommerce();
            }}
            noPlans={filteredPlans.length === 0}
            data-panel='desempeno-upgradePlanModal-cta-buyPlan'
          >
            {t('panel.avisos.upgrade.plan.modal.cta2')}
          </Button>
        )}
        <Button
          className='PUBLISH-MODAL-BUTTON-CTA'
          disabled={!AvailableCredits.some(c => c.checked)}
          onClick={() => {
            sendTrackingInfo('Panel', 'Mis avisos', 'Mejora tu plan-Cambiar');
            publish(posting, AvailableCredits);
          }}
          noPlans={noCredits}
          noEcommerce={!ecommercePath}
          data-panel='desempeno-upgradePlanModal-cta-upgradePlan'
        >
          {t('panel.avisos.upgrade.plan.modal.cta1')}
        </Button>
      </ButtonContainer>
    </Container>
  );
};

export default UpgradePlanModal;

const Container = styled.div`
  padding: 48px 32px 32px 32px;
  width: ${({ device }) => device !== 'mobile' && '400px'};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h1`
  font-family: Hind;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
  margin-bottom: 8px;
  white-space: pre-line;
`;

const Text = styled.div`
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
  margin-bottom: 24px;
  white-space: pre-wrap;
`;

const SubTitle = styled.div`
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: ${select('darkGray')};
  margin-bottom: 16px;
  align-self: flex-start;
  white-space: pre-wrap;
  text-align: center;
`;

const PlanContainer = styled.span`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
  :last-of-type {
    margin-bottom: 32px;
  }
  > label {
    font-family: Hind;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0em;
    display: flex;
    align-items: center;
    color: ${({ disabled }) => disabled && select('darkGray')};
    > span {
      &.upgradeModal-planName-mobile {
        overflow: hidden;
        max-width: 190px;
        text-overflow: ellipsis;
      }
      &.upgradeModal-planName-desktop {
        max-width: 240px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &.upgradeModal-planName-tablet {
        max-width: 240px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    > div {
      position: relative;
      top: -1px;
    }
  }
`;

const AvailableCreditsText = styled.div`
  font-family: Hind;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: right;
  color: ${select('midDarkGray')};
`;

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  justify-self: flex-end;
  margin-top: 25px;
  ${({ device }) =>
    device === 'mobile' &&
    css`
      flex-direction: column;
      gap: 15px;
    `}
`;

const Button = styled.button`
  min-width: ${({ noPlans }) => (!noPlans ? '140px' : '100%')};
  padding: 0 12px;
  height: 48px;
  border-radius: 8px;
  border: 1px solid ${getColor('primary')};
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  :hover {
    background-color: ${getColor('tertiary')};
  }
  &.PUBLISH-MODAL-BUTTON-CTA {
    background-color: ${({ disabled }) => (!disabled ? getColor('primary') : select('lightGray'))};
    border-color: ${({ disabled }) => disabled && select('lightGray')};
    color: ${({ disabled }) => (!disabled ? 'white' : select('midLightGray'))};
    display: ${({ noPlans }) => noPlans && 'none'};
    width: ${({ noEcommerce }) => noEcommerce && '100%'};
    :hover {
      background-color: ${({ disabled }) => !disabled && getColor('secondary')};
    }
  }
`;

const Img = styled.div`
  background-image: url(${({ src }) => src});
  width: 145px;
  height: 96px;
  margin-bottom: 32px;
`;
